export default "__VITE_ASSET__DMNPGrg9__"